<mat-form-field
    subscriptSizing="dynamic"
    class="st-search-box"
    [class.st-search-box-inactive]="!searchOpen">
    <input
        class="st-search-box-input"
        matInput
        matAutocompleteTrigger
        [formControl]="searchFilter"
        [placeholder]="languageSettings.PSTWebSearchPlaceholder"
        [matAutocomplete]="auto"
        [(ngModel)]="searchTherm"
        (keyup)="onKeyUp($event)"
        (keydown)="onKeyDown($event)" />
    <button
        matPrefix
        mat-icon-button
        class="st-search-box-toggle"
        [matTooltip]="languageSettings.PSTWebSearchLabel"
        (click)="openSearch()">
        <mat-icon>search</mat-icon>
    </button>
    <button
        class="st-search-box-close"
        matSuffix
        mat-icon-button
        (click)="closeSearch()">
        <mat-icon>close</mat-icon>
    </button>
    <mat-autocomplete
        #auto="matAutocomplete"
        [displayWith]="displayFn.bind(this)"
        (optionSelected)="optionSelected($event)">
        <mat-option
            *ngFor="let value of suggestions | async"
            class="st-search-box-suggestion-option"
            [value]="value">
            <div class="st-search-box-suggestion">
                <st-avatar
                    *ngIf="isStaffSearch"
                    class="st-search-box-suggestion-avatar"
                    big
                    [userId]="getUserId(value)" />
                <span class="st-search-box-suggestion-label"> {{ getDisplayValue(value) }} </span>
            </div>
        </mat-option>
    </mat-autocomplete>
</mat-form-field>
